module.exports = __webpack_public_path__ + "static/media/defaultJobImage.09a31925.png";